const rol = {
  user: 1,
  admin: 2,
  gestor: 3,
  empresa: 4,
  eps: 5,
}

export default rol
